import { Recipe } from '@gnocchi.biscuits/verdant';

export function makeRecipeLink(recipe: Recipe, path: '' | '/edit' = '') {
	return `/recipes/${sanitizeForUrl(
		recipe.get('title') || 'recipe',
	)}-${recipe.get('slug')}${path}`;
}

function sanitizeForUrl(text: string) {
	return text
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '')
		.slice(0, 50);
}

export function makeRecipeSlug(recipe: Recipe) {
	return `${sanitizeForUrl(recipe.get('title') || 'recipe')}-${recipe.get(
		'slug',
	)}`;
}
